import { render, staticRenderFns } from "./view_by_id.vue?vue&type=template&id=3e5dd6f7&scoped=true&"
import script from "./view_by_id.vue?vue&type=script&lang=ts&"
export * from "./view_by_id.vue?vue&type=script&lang=ts&"
import style0 from "./view_by_id.vue?vue&type=style&index=0&id=3e5dd6f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5dd6f7",
  null
  
)

export default component.exports